const { orderTypes, orderSides } = require("./OrderUtils");
const { DEFAULT_SYMBOL } = require("./SymbolUtils");

const DEFAULT_ORDER_TEMPLATE = {
    name: '',
    symbol: DEFAULT_SYMBOL,
    type: orderTypes.MARKET,
    side: orderSides.BUY,
    limitPrice: '',
    limitPriceMultiplier: 1,
    stopPrice: '',
    stopPriceMultiplier: 1,
    quantity: '',
    quantityMultiplier: 1,
    icebergQty: '',
    icebergQtyMultiplier: 1,
    tp1Percent: '',
    tp1Quantity: '',
    tp2Percent: '',
    tp2Quantity: '',
    tp3Trailing: false,
    tp3TrailingStop: '',
    tp3AtrMultiplier: '',
    moveStopOnTp1: false,
    regimeSizing: null,
    regimeStopMultiplier: null,
    isFuture: false,        // futuros (Fase 3.4): template usado pela ação FUTURES_ORDER
    leverage: '',           // alavancagem (ex: 3)
    marginType: '',         // ISOLATED | CROSSED | '' (manter)
    reduceOnly: false       // só reduz/fecha posição (saída do short)
};

module.exports = {
    DEFAULT_ORDER_TEMPLATE
}